export default {
  namespaced: true,
  state: {
    isEditDrawerShow: false, // 切换左侧是否显示
    currentEditHeader: 'catalog', // 控制左侧显示树还是编辑区域
    listToEditPageNo: 1,
    isTrue: false,
    isTurnEdit: false
  },
  mutations: {
    IS_TRUE(state, isTrue) {
      state.isTrue = isTrue
    },
    // 切换左侧是否显示
    UPDATE_EDIT_DRAWER_SHOW(state, isEditDrawerShow) {
      state.isEditDrawerShow = isEditDrawerShow
    },
    // 控制左侧显示树还是编辑区域
    UPDATE_EDIT_HEADER_TYPE(state, currentEditHeader) {
      state.currentEditHeader = currentEditHeader
    },
    UPDATE_TURN_EDIT(state, isTurnEdit) {
      state.isTurnEdit = isTurnEdit
    },
    UPDATE_LIST_TO_PAGE_NO(state, pageNo) {
      state.listToEditPageNo = pageNo
    }
  }
}
